import request from '@/utils/request'

export const login = (data: any) =>
  request({
    url: '/OAuth/authenticate',
    method: 'post',
    data
  })

export const logout = () =>
  request({
    url: '/users/logout',
    method: 'post'
  })
